import React, { useState, useEffect } from 'react';
import { Drawer, Steps } from '@b-design/fusion';
import $i18n from '../../i18n';
import Confirm from './component/confirm';
import Submit from './component/submit';

import './index.less';
interface VersionDescription {
  // 应用名称
  name: string;
  // 应用id
  appId: string;
  // 应用logo地址
  iconPublicUrl: string;
  // 应用标语
  slogan: string;
  // 应用描述
  description: string;
  // 联系邮箱
  customerEmail: string;
  // 联系电话
  customerPhone: string;
  // 是否继承（标识,用于调用不同接口）
  inherit: boolean;
}
interface App {
  // app信息框架
  framework: string;
}
interface VersionDetail {
  // 创建人
  createName: string;
  // 创建时间
  gmtCreate: string;
  // 修改时间
  gmtModified: string;
  // 发布描述
  changelog: string;
  // 应用所在渠道名称
  channelName: string;
  // 应用版本
  version: string;
  // 应用id
  appId: string;
  // 应用渠道id
  channelCode: string;
  // 版本描述
  versionDescription: VersionDescription;
  // app描述
  app: App;
}
interface Props {
  // 空间id
  spaceId: string | (string | null)[] | null;
  // 抽屉表单显隐
  visible: boolean;
  // 抽屉表单显隐回调
  setVisible: (v: boolean) => void;
  // 版本信息详情
  versionDetail: VersionDetail;
  // 初始化数据函数
  initDataSource: () => void;
}

const ApplyReleasing: React.FC<Props> = ({
  visible,
  setVisible,
  versionDetail,
  initDataSource,
  spaceId,
}) => {
  const [curSteps, setCurSteps] = useState(0);
  const renderForm = () => {
    if (curSteps === 0) {
      return (
        <Confirm setCurSteps={setCurSteps} setVisible={setVisible} versionDetail={versionDetail} />
      );
    } else {
      return (
        <Submit
          setVisible={setVisible}
          versionDetail={versionDetail}
          initDataSource={initDataSource}
          spaceId={spaceId || ''}
        />
      );
    }
  };

  useEffect(() => {
    setCurSteps(0);
  }, [visible]);

  return (
    <Drawer
      className="apply-release-drawer"
      title={$i18n.get({
        id: 'aopf.pages.miniapp.version.tabs.release.Apply.Release',
        dm: '应用版本',
      })}
      placement="right"
      data-size="large"
      onClose={() => setVisible(false)}
      visible={visible}
      headerStyle={{
        fontWeight: 500,
        fontSize: 16,
        color: '#121c2d',
        letterSpacing: '0.15px',
        lineHeight: '24px',
      }}
    >
      <Steps current={curSteps} shape="arrow" data-nav>
        <Steps.Item
          key={1}
          title={$i18n.get({
            id: 'aopf.pages.miniapp.version.info.process.Confirm.Release',
            dm: '确认发布信息',
          })}
        />
        <Steps.Item
          key={2}
          title={$i18n.get({
            id: 'aopf.pages.miniapp.version.info.process.Submit.For.Release',
            dm: '提交并发布',
          })}
        />
      </Steps>
      {renderForm()}
    </Drawer>
  );
};

export default ApplyReleasing;
